var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke: #fff;\r\n      }\r\n\r\n      .cls-3 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #fff;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_539",
    "data-name": "Rectangle 539",
    className: "cls-1",
    width: 53.624,
    height: 53.698,
    transform: "translate(0 0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_672",
    "data-name": "Group 672"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_343",
    "data-name": "Rectangle 343"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    className: "cls-1",
    d: "M50,0h0a50,50,0,0,1,50,50h0a50,50,0,0,1-50,50h0A50,50,0,0,1,0,50H0A50,50,0,0,1,50,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    className: "cls-2",
    d: "M50,2.5h0A47.5,47.5,0,0,1,97.5,50h0A47.5,47.5,0,0,1,50,97.5h0A47.5,47.5,0,0,1,2.5,50h0A47.5,47.5,0,0,1,50,2.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1042",
    "data-name": "Group 1042",
    transform: "translate(23.188 23.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1040",
    "data-name": "Group 1040",
    className: "cls-3",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    className: "cls-4",
    d: "M.052,53.7A2.129,2.129,0,0,1,.2,53.48q7.7-8.769,15.4-17.535l5.172-5.889c.054-.062.106-.125.168-.2L0,.006H.346Q8.022.006,15.7,0a.477.477,0,0,1,.445.234q6.727,9.6,13.464,19.2l.217.309c.37-.419.725-.821,1.079-1.224Q38.952,9.362,47,.2A.506.506,0,0,1,47.42,0c1.39.008,2.779,0,4.169,0h.319L31.94,22.741c.054.081.1.156.153.229l21.386,30.5c.052.074.1.154.145.23H37.647c-.034-.057-.064-.116-.1-.17q-7.184-10.242-14.37-20.482c-.04-.058-.087-.111-.139-.178-.114.128-.213.239-.312.351L12.763,44.564,4.746,53.7ZM6.445,3.5c.1.14.156.227.217.312q5.762,8.07,11.524,16.141Q28.953,35.04,39.715,50.131a.542.542,0,0,0,.5.267c2.2-.011,4.41-.006,6.614-.006h.341c-.086-.122-.136-.2-.188-.267Q30.422,26.915,13.86,3.7a.439.439,0,0,0-.41-.207q-3.345.009-6.689,0Z",
    transform: "translate(0 -0.001)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.78fa436541024210b8f7c0fd9a5d744e.svg";
export { ForwardRef as ReactComponent };